<template>
<div>
    <div id="contents" v-show="mode === MODE.SEARCH">
        <div class="contents_wrap" >
            <h2 class="pg_title">
                <!-- 활성화된 링크에 active -->
                <a href="javascript:" class="" @click="moveKnowledge($event)">Local Service Bulletin - List</a>
                <a href="javascript:" class="active">Mobile (Other Languages)</a>
            </h2>
            <!-- breadcrumbs -->
            <skp-breadcrumbs @page-title="val => (pageTitle = val)" />
            <!-- //breadcrumbs -->

            <!-- srchTop_wrap -->
            <div class="srchTop_wrap">
                <article class="srch_basic">
                    <div class="srch_grup">
                        <ul class="w100">
                            <li class="tit_150" data-input-type="select">
                                <select class="slt_white w140p" v-model="SEARCH">
                                    <option value="Title+Keyword" selected>Title + Keyword</option>
                                    <option value="Title">Title</option>	            			
                                </select>
                            </li>
                            <li class="srch_a" data-input-type="input">
                                <span class="clearable">
                                    <input type="text" class="text_input w100"
                                        placeholder="Title"
                                        v-model="TITLE"
                                        v-clearable
                                        />
                                </span>
                            </li>
                        </ul>
                        <ul class="w100">
                            <li class="tit_150">Date</li>
                            <li data-input-type="date">
                                <fieldset class="ui_fieldset">
                                    <label class="date-wrap">
                                        <input
                                            id="fromDate"
                                            type="text"
                                            class="date_input w100"
                                            maxlength="20"
                                            placeholder="From Date"
                                            readonly
                                        />
                                        <a href="javascript:" class="in_btn" id="icoFromDate">
                                            <i class="ico_date"></i>
                                            <span class="sr_only">Open Calendar</span>
                                        </a>
                                    </label>
                                    <div id="from-picker-container" />
                                    <em class="txt_space"></em>
                                    <label class="date-wrap">
                                        <input
                                            id="toDate"
                                            type="text"
                                            class="date_input w100"
                                            maxlength="20"
                                            placeholder="To Date"
                                            readonly
                                        />
                                        <a href="javascript:" class="in_btn" id="icoToDate">
                                            <i class="ico_date"></i>
                                            <span class="sr_only">Open Calendar</span>
                                        </a>
                                    </label>
                                    <div id="to-picker-container" style="margin-top: -1px;" />
                                </fieldset>
                            </li>
                        </ul>
                        <ul class="w49">
                            <li class="tit_150">Urgency</li>
                            <li data-input-type="select" class="w100-150">
                                <select class="slt_white w100" v-model="URGENCY">
                                    <option value="">All</option>
                                    <option value="Y">Y</option>
                                    <option value="N">N</option>
                                </select>
                            </li>
                        </ul>
                        <ul class="w49">
                            <li class="tit_150">User Level</li>
                            <li data-input-type="select" class="w100-150">
                                <select class="slt_white w100" v-model="USER_LEVEL">
                                    <option
                                        v-for="item in userLevelList"
                                        :key="item.CODE_ID"
                                        :value="item.CODE_ID"
                                    >{{item.CODE_NAME}}</option>
                                </select>
                            </li>
                        </ul>
                        <ul class="w49">
                            <li class="tit_150">Type1</li>
                            <li data-input-type="select" class="w100-150">
                                <select class="slt_white w100" v-model="TYPE1">
                                    <option value="">ALL</option>
                                    <option value="Guide">Guide</option>
                                    <option value="Bulletin">Bulletin</option>
                                </select>
                            </li>
                        </ul>
                        <ul class="w49">
                            <li class="tit_150">Type2</li>
                            <li data-input-type="select" class="w100-150">
                                <select class="slt_white w100"
                                    v-if="TYPE1 === 'Guide' || TYPE1 === ''" v-model="TYPE2_G"
                                >
                                    <option value="">ALL</option>
                                    <option value="Common">Common</option>
                                    <option value="IMEI">IMEI</option>
                                    <option value="Policy / Process"  >Policy / Process</option>
                                    <option value="SW Tool">SW Tool</option>
                                    <option value="Jig / Equipment" >Jig / Equipment</option>
                                    <option value="Training Material"  >Training Material</option>
                                </select>
                                <select class="slt_white w100"
                                    v-if="TYPE1 === 'Bulletin'" v-model="TYPE2_B"
                                >
                                    <option
                                        v-for="item in bulletinType2List"
                                        :key="item"
                                        :value="item"
                                    >{{item}}</option>
                                </select>

                            </li>
                        </ul>
                        <ul class="w49">
                            <li class="tit_150">Language</li>
                            <li data-input-type="select" class="w100-150">
                                <select class="slt_white w100" v-model="LANGUAGE">
                                    <option value="">All</option>
                                    <option value="1">Spanish</option>
                                    <option value="2">French</option>
                                    <option value="3">German</option>
                                    <option value="4">Russian</option>
                                </select>
                            </li>
                        </ul>
                        <ul class="w49">
                            <li class="tit_150">Modified</li>
                            <li data-input-type="select" class="w100-150">
                                <select class="slt_white w100" v-model="MODIFIED">
                                    <option value="">All</option>
                                    <option value="Y">Y</option>
                                    <option value="N">N</option>
                                </select>
                            </li>
                        </ul>
                    </div>
                    <div class="srch_grupR">
                        <span class="btn">
                            <a href="javascript:" class="btn_srch" @click="onSearchClick">Search</a>
                        </span>
                    </div>
                </article>
            </div>
            <!-- Grid -->
            <div class="grid_wrap">
                <!-- Grid Count-->
                <div class="grid_total">
                    Total Count
                    <em>{{ resultCount | numberFormat }}</em>
                </div>
                <!-- Grid "btn-->
                <!-- <div class="btn_wrap">
                    <a href="javascript:" class="btn_gray" title @click="$router.push({name:'hhpServiceBulletinCreate'})">New</a>
                </div> -->
                <!-- Grid -->
                <div id="grid">
                    <toast-grid
                        gridId="gridBulletin"
                        ref="gridBulletin"
                        :key="gridKey"
                        :data="gridData"
                        :columns="gridColumns"
                        :header="gridHeader"
                        :options="gridOptions"
                        :pageOptions="gridPageOptions"
                        :theme="gridTheme"
                        :isTotalCount="false"
                        v-bind:click="onGridCellClick"
                    />
                </div>

                <div class="paginate">
                    <sdl-pagination
                        :current-page="currentPage"
                        :total-rows="resultCount"
                        :per-page="perPage"
                        @change="onGoToPage"
                        align="center"
                    />
                </div>
            </div>

        </div>
        <div v-show="false">
        </div>
    </div>
    <bulletin-view v-if="mode === MODE.VIEW" :seq="view.seq" :onBackToList="onBackToList" />
</div>

</template>

<script>
import Vue            from 'vue';

import { mapGetters } from 'vuex';

import axios from 'axios';
import qs from 'query-string';
import moment from 'moment';

import { SDLUtil, StringUtil, DateUtil } from '@/utils';

import SKPBreadcrumbs from '~vb/main/SKPBreadcrumbs';

import DatePicker from '~c/DatePicker';

import Pagination from '@/components/common/control/pagination/Pagination';
import ToastGrid from '~c/ToastGrid';

import { CellHtmlRenderer, HeaderHtmlRenderer, } from '~c/GridCustomRenderer';

import InnorixDownload from '~c/InnorixDownload';

import BulletinView from './BulletinOtherView';

const MODE = {
    SEARCH: 1,
    VIEW: 2,
};

export default {
    name: '',
    components: {
        'skp-breadcrumbs': SKPBreadcrumbs,
        'toast-grid': ToastGrid,
        'sdl-pagination': Pagination,
        'bulletin-view': BulletinView,
        'innorix-download': InnorixDownload,
    },
    created() {},
    data() {
        return {
            ...mapGetters({
                locale: 'getLocale',
            }),

            pageTitle: '',

            MODE,
            mode: MODE.SEARCH,

            view: {
                seq: '',
            },

            roleCd: '', // my Role Code

            SEARCH: 'Title+Keyword',
            TITLE: '',
            TYPE1: '',
            TYPE2: '',
            TYPE2_B: '',
            TYPE2_G: '',
            URGENCY: '',
            USER_LEVEL: '',
            MODIFIED: '',
            LANGUAGE: '',

            rangePicker: null,
            startDate: {},
            endDate: {},
            searchToAddDt: '',
            searchFromAddDt: '',

            bulletinType2List: [],
            userLevelList: [],

            resultCount: 0,

            currentPage: 1,
            perPage: parseInt(localStorage.getItem('listRows') || 10),

            gridKey: 0,
            gridData: [],

            gridHeader: {
                // height: 100,
                //complexColumns: []
                columns: [
                    {
                        name: 'REPROCESS_YN',
                        renderer: HeaderHtmlRenderer,
                    },
                    {
                        name: 'NEED_REPROCESS',
                        renderer: HeaderHtmlRenderer,
                    },
                ],
            },
            gridColumns: [
                {
                    header: 'No',
                    name: 'RNUM',
                    width: 60,
                    align: 'right',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'Modified',
                    name: 'MODIFIED',
                    width: 80,
                    align: 'center',
                    renderer: CellHtmlRenderer,
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'Title',
                    name: 'TITLE',
                    align: 'left',
                    resizable: false,
                    sortable: false,
                    className: 'cur_pointer',
                },
                {
                    header: 'Type1',
                    name: 'TYPE1',
                    width: 140,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'Type2',
                    name: 'TYPE2',
                    width: 140,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'Registered',
                    name: 'REG_DT',
                    width: 140,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'Views',
                    name: 'R_COUNT',
                    width: 60,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'Downs',
                    name: 'FILE_DOWN_COUNT',
                    width: 60,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
            ],
            gridOptions: {
                scrollX: false,
                scrollY: false,
            },
            gridPageOptions: null,
            gridTheme: {
                name: 'skpTheme', // required
                value: {
                    // required
                    row: {
                        hover: {
                            background: '#FBFBFC',
                        },
                    },
                    // cell: {
                    //     normal: {
                    //         background: '#00ff00',
                    //         border: '#e0e0e0'
                    //     },
                    //     head: {
                    //         background: '#ff0000',
                    //         border: '#ffff00'
                    //     },
                    // },
                },
            },

        };
    },

    created() {
        this.init();

    },
    mounted() {
        // 범위 지정 Datepicker 로 변경
        this.rangePicker = DatePicker.createRangeWithOpener(
            'from-picker-container', 'fromDate', 'icoFromDate',
            'to-picker-container', 'toDate', 'icoToDate',
            { type: 'date', locale: 'en', showToday: false },
            (new moment()).add(-3, 'years').toDate(),
            (new moment()).toDate()
        );
    },
    methods: {
        async init() {
            const data = await this.fetchInitData()
                .catch(err => {

                });
            this.roleCd = data.roleCd;
            this.setBulletinType2List(data.bulletinType2List);
            this.setUserLevelList(data.userLevelList);
        },
        fetchInitData() {
            return (
                axios
                    // Loads data such as list of countries, etc...
                    .get(`${SDLUtil.API_URL}/basis/anysvcmobile/svcBulletin/sbOtherList.skp`)
                    .then(res => {
                        console.log('SvcBulletin RESPONSE',res);
                        console.log('SvcBulletin RESPONSE DATA',res.data);
                        // res.data.rows => [['CODE_NAME', 'CODE_ID'], ...]
                        // console.log('LOG', this.availableParentCodeList);
                        return res.data;
                    })
                    // .catch(err => {
                    //     console.log(`SvcBulletin ERROR =>>`, err);
                    //     return res.data;
                    // })
            );
        },

        setBulletinType2List(list) {
            list = list.map(item => {
                return item.TYPE2;
            });
            this.bulletinType2List = list;
        },

        setUserLevelList(list) {
            if (this.roleCd === 'S05') {
                list.unshift({CODE_ID: 'ALL', CODE_NAME:'ALL'});
                this.USER_LEVEL = 'ALL';
            } else {
                list = list.filter(item => item.CODE_ID === this.roleCd);
                this.USER_LEVEL = this.roleCd;
            }
            this.userLevelList = list;
        },

        onSearchClick() {
            this.doSearch(1);
        },

        async doSearch(pageNo) {
            const params = this.prepSearchParams(pageNo);
            SDLUtil.showLoadingBar(true);
            const data = await this.fetchSearchResult(params);
            this.setSearchResult(data);
            this.currentPage = pageNo;
            this.lastSearchParams = params;
            SDLUtil.showLoadingBar(false);
        },

        prepSearchParams(pageNo) {
            if (!pageNo) pageNo = 1;

            const format = moment().toMomentFormatString(localStorage.getItem('dateFormat') || 'MM.dd.yyyy');
            const searchFromAddDt = this.rangePicker.getStartDate()
                ? moment(this.rangePicker.getStartDate()).formatWithJDF(format)
                : '';
            const searchToAddDt = this.rangePicker.getEndDate() ? moment(this.rangePicker.getEndDate()).formatWithJDF(format) : moment().formatWithJDF(format);

            const params = {
                page: pageNo,
                USER_LEVEL: this.USER_LEVEL,
                URGENCY_YN: this.URGENCY,
                TYPE1: this.TYPE1,
                TYPE2: this.TYPE1 === 'Bulletin' ? this.TYPE2_B : this.TYPE2_G,
                TYPE2_G: this.TYPE2_G,
                TYPE2_B: this.TYPE2_B,
                LANGUAGE: this.LANGUAGE, // 1 - English
                SEARCH: this.SEARCH, // search type
                TITLE: this.TITLE, // search Keyword
                MODIFIED: this.MODIFIED,
                PERIOD_S: searchFromAddDt,
                PERIOD_E: searchToAddDt,
            };

            // if (exclude.length > 0) {
            //     exclude.forEach(item => {
            //         if (item in params) delete params[item];
            //     });
            // }

            console.log('search params', params);
            return params;
                
        },

        fetchSearchResult(formData) {
            return axios
                .post(
                    `${SDLUtil.API_URL}/basis/anysvcmobile/svcBulletin/sbOtherListSearch.skp`,
                    qs.stringify(formData),
                    {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        },
                        params: { searchInfo: 'set' },
                    },
                )
                .then(res => {
                    console.log('SEARCH RESULT =>> ', res);
                    // this.resultCount = resp.data.count;
                    // this.gridData = Object.assign([], resp.data.rows);
                    return res.data;
                    // this.searchStatus = 'done';
                    // this.loadingStatus = 'done';

                    // this.currentPage = pageNo;
                    // this.gridKey += 1; // This will re-render grid
                    // SDLUtil.showLoadingBar(false);
                });
                // .catch(err => {
                //     Vue.$log.error('SEARCH ERROR =>> ', err);
                //     this.searchStatus = 'error';
                //     this.gridData = [];
                //     SDLUtil.showLoadingBar(false);
                // });


        },

        setSearchResult(data) {
            function color(value) {
                if (value === 'Y') return 'blue';
                if (value === 'N') return 'red';
                return 'auto';
            }
            function toColoredTag(value) {
                return `<span style="color: ${color(value)}">${value}</span>`;
            }
            const rows = data.rows.map(row => {
                // Make sure CustomHtmlCell
                row.REPROCESS_YN = toColoredTag(row.REPROCESS_YN);
                row.NEED_REPROCESS = toColoredTag(row.NEED_REPROCESS);
                row.MODIFIED = toColoredTag(row.MODIFIED);
                return row;
            });

            this.resultCount = data.count;
            if (
                typeof data.rows !== 'undefined' &&
                data.rows.length === 0
            ) {
                this.resultCount = 0;
            }

            this.gridData = data.rows;

            this.gridKey += 1;
        },

        onGoToPage(pageNo) {
            // this.lastSearchParams.page = pageNo;
            this.doSearch(pageNo);
        },

        onGridCellClick(event, rowData) {
            console.log(event);
            if (typeof event.rowKey === 'undefined') return;
            const row = rowData[event.rowKey];
            // console.log('event rowKey', event.rowKey);
            // console.log('event columnName', event.columnName);
            // console.log('event rowData', rowData);
            console.log('event row', rowData[event.rowKey]);
            if (event.columnName === 'TITLE') {
                this.viewContent(row.SEQ)

            }
            console.log('')

        },
        viewContent(seq) {
            this.view.seq = seq;
            this.switchMode(MODE.VIEW);
        },

        switchMode(mode) {
            this.mode = mode;
        },

        onBackToList() {
            this.switchMode(MODE.SEARCH);
        },

        moveKnowledge(ev) {
            let BOARD_ID = localStorage.getItem('sbBoardId');

            if (BOARD_ID == null) BOARD_ID = '';

            this.$router.push({
                path: '/basis/knowledge/knowledgeList',
                query: { BOARD_ID } ,
            });
        },

    },
};
</script>

<style>
.zindex9999 {
    z-index: 9999;
}
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/anysvcmobile/svcBulletin/BulletinOtherList.vue